import { render } from "./ThanksPage.vue?vue&type=template&id=6365a59c"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__